"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.244 4.42L20.998 3v8.534l-9.754.077V4.419zm-.888.13L3 5.548l.007 6.117 7.352-.042-.003-7.073zm.002 14.968l-.005-7.08-7.348-.047v6.12l7.353 1.007zM20.998 21L21 12.505l-9.77-.016.014 7.139L20.998 21z" }), "Window");
//# sourceMappingURL=Windows.js.map